import config from "@@/config";
import { defineStore } from "pinia";
import useAuthUser from "@/composables/auth/useAuthUser.js";

export const useCurrencyStore = defineStore("currency", {
	state: () => ({
		currencies: [],
		current: "",
		user: null,
	}),

	getters: {
		getCurrencies(state) {
			return state.currencies;
		},
		getDefault(state) {
			return this.getCurrencies.reduce((result, element) => (element.is_default || element.default ? element : result), {});
		},
		getBySlug(state) {
			return (slug) => {
				return this.getCurrencies.find((element) => element.slug.toLowerCase() === slug?.toLowerCase());
			};
		},
		getCurrent(state) {
			return state.current;
		},
		getExists(state) {
			return (slug) => {
				return !!this.getCurrencies
					.map((currency) => currency.slug)
					.some((currency) => "" + currency.toLowerCase() === "" + slug.toLowerCase());
			};
		},
		getHasCurrency(state) {
			return null !== this.getCurrent && this.getExists(this.getCurrent);
		},

		getCurrency(state) {
			if (this.getHasCurrency && this.getCurrent) return this.getCurrent ?? "";
			return this.getDefault.slug ?? "";
		},
		getCurrencyObject(state) {
			return this.getBySlug(this.getCurrency);
		},
		getCurrencyName(state) {
			const currencyObject = this.getCurrencyObject;

			if (typeof currencyObject !== "object") return "";

			if ("locale_translation" in currencyObject) return currencyObject.locale_translation.name;

			return currencyObject.name;
		},
	},

	actions: {
		init(force = false) {
			const { userCurrency } = useAuthUser();

			this.setCurrencies();

			this.setCurrent(userCurrency.value);
		},
		setCurrencies(currencies) {
			if (!currencies || !Array.isArray(currencies)) this.currencies = config.currencies;
			else this.currencies = currencies;
		},
		setCurrent(slug = null) {
			if (!slug) slug = this.getDefault.slug;

			if (typeof slug === "object") slug = slug.slug;

			if (!this.getExists(slug)) return false;

			this.current = slug;

			return true;
		},
		destroy() {
			this.$reset();
		},
	},
});
